import { Module } from 'vuex'
import { RootState } from '@/Common/store/types'
import { TaskState } from './types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { state } from './state'

const namespaced: boolean = true

export const task: Module<TaskState, RootState> = {
  namespaced,
  state,
  mutations,
  getters,
  actions,
}
